import HttpClient from './utils/HttpClient';
import APIError from '../errors/APIError';
import { Group, Product } from './GroupsService';

export interface IPromotion {
  name: string,
	description: string,
	type: number,
	value: number,
	typeValue: number,
	minValue: number,
	maxValue: number,
	general: boolean,
	cumulative: boolean,
	isFirstPurchase: boolean,
	inTheDelivery: boolean,
	startDate: string | null,
	endDate: string | null,
	companyId: number,
  active: boolean,
	updatedAt: string | null,
	deletedAt: string | null,
	inactivedAt: string | null,
	id: number,
	createdAt: string,
  productPromotion: {
    id: number,
    promotionId: number,
    productId: number,
    primary: boolean,
    createdAt: string,
    deletedAt: string | null
    product: Product & { 
      groupProduct: {
        id: number,
        groupId: number,
        productId: number,
        deletedAt: string | null
      }[]
    }
  }[],
  groupPromotion: {
    id: number,
    promotionId: number,
    groupId: number,
    primary: boolean,
    createdAt: string,
    deletedAt: string | null
    group: Group
  }[],
}

class PromotionsService {
  private httpClient = HttpClient;

  public async getPromotion(promotionId: number, companyId: number): Promise<IPromotion> {
    try {
      const response = await this.httpClient.get(`/companies/${companyId}/promotions/${promotionId}`);

      return response.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar listar as promoções';
      }

      throw new APIError(errorMessage);
    }
  }

  public async listPromotions(companyId: number, filter: string, type: number): Promise<IPromotion[]> {
    try {
      const response = await this.httpClient.get(`/companies/${companyId}/promotions?filter=${filter}&type=${type}`);

      return response.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar listar as promoções';
      }

      throw new APIError(errorMessage);
    }
  }

  public async createPromotion(
    companyId: number,
    name: string,
    description: string,
    minimumValue: number,
    maximumValue: number,
    typeValue: number,
    value: number,
    startDate: string,
    endDate: string,
    isFirstBuy: boolean,
    isCumulative: boolean,
    type: number,
    productIds: number[],
    groupIds: number[],
    productIdsSecond: number[],
    groupIdsSecond: number[],
  ): Promise<IPromotion> {
    try {
      const response = await this.httpClient.post(`/companies/${companyId}/promotions`, {
        name,
        minValue: minimumValue,
        maxValue: maximumValue,
        typeValue,
        value,
        startDate: startDate ? startDate : null,
        endDate: endDate ? endDate : null,
        inTheDelivery: true,
        isFirstPurchase: isFirstBuy,
        cumulative: isCumulative,
        type,
        description,
        main: {
          productIds,
          groupIds
        },
        secondary: {
          productIds: productIdsSecond,
          groupIds: groupIdsSecond
        }
      });

      return response.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar listar as promoções';
      }

      throw new APIError(errorMessage);
    }
  }

  public async editPromotion(
    promotionId: number,
    companyId: number,
    name: string,
    description: string,
    minimumValue: number,
    maximumValue: number,
    typeValue: number,
    value: number,
    startDate: string,
    endDate: string,
    isFirstBuy: boolean,
    isCumulative: boolean,
    active: boolean,
    type: number,
    productIds: number[],
    groupIds: number[],
    productIdsSecond: number[],
    groupIdsSecond: number[],
  ): Promise<IPromotion> {
    try {
      const response = await this.httpClient.put(`/companies/${companyId}/promotions/${promotionId}`, {
        name,
        minValue: minimumValue,
        maxValue: maximumValue,
        typeValue,
        value,
        startDate: startDate ? startDate : null,
        endDate: endDate ? endDate : null,
        inTheDelivery: true,
        isFirstPurchase: isFirstBuy,
        cumulative: isCumulative,
        type,
        description,
        active,
        main: {
          productIds,
          groupIds
        },
        secondary: {
          productIds: productIdsSecond,
          groupIds: groupIdsSecond
        }
      });

      return response.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar listar as promoções';
      }

      throw new APIError(errorMessage);
    }
  }

  public async deletePromotion(promotionId:number, companyId: number): Promise<IPromotion> {
    try {
      const response = await this.httpClient.delete(`/companies/${companyId}/promotions/${promotionId}`);

      return response.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar listar as promoções';
      }

      throw new APIError(errorMessage);
    }
  }
}

export default new PromotionsService();